<template>
  <div>
    <b-card>
      <b-row class="align-items-center">
        <b-col class="col-lg-2 col-md-3 col-12">
          <b-form-group :label="$t('sla.problem_type')" for="problemType">
            <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                id="problemType"
                label="title"
                v-model="filter.problem_type"
                :options="GET_LIST_APPEAL_PROBLEM_TYPE"
                :reduce="(p) => p.id"
                @input="filterProblem"
            />
          </b-form-group>
        </b-col>

        <b-col class="col-lg-2 col-md-3 col-12">
          <b-form-group :label="$t('task_manager.priority')" for="Priority">
            <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                id="Priority"
                label="title"
                v-model="filter.priority"
                :options="GET_LIST_APPEAL_PRIORITY_FILTER"
                :reduce="(p) => p.id"
                @input="filterPriority"
            />
          </b-form-group>
        </b-col>

        <b-col class="col-lg-2 col-md-3 col-12">
          <b-form-group :label="$t('status')" for="status">
            <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                id="status"
                label="title"
                v-model="filter.status"
                :options="GET_LIST_APPEAL_STATUS_FILTER"
                :reduce="(opt) => opt.unique_name"
                @input="filterStatus"
            />
          </b-form-group>
        </b-col>

        <b-col class="col-lg-2 col-md-3 col-12">
          <b-form-group :label="$t('sla.date_sync')" for="synchronizationTime">
            <flat-pickr
                v-model="filter.start_time"
                id="synchronizationTime"
                class="form-control"
            />
          </b-form-group>
        </b-col>

        <b-col class="col-lg-2 col-md-3 col-12">
          <b-form-group class="mb-0 mt-1" for="time">
            <flat-pickr
                v-model="filter.end_time"
                id="time"
                class="form-control"
            />
          </b-form-group>
        </b-col>

        <b-col class="col-lg-2 col-md-3 col-12">
          <b-button
              class="mt-1 float-right"
              variant="outline-danger"
              @click="resetInputFields"
          >
            {{ $t('clear') }}
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-card>
      <vue-good-table
          class="table-hover"
          :columns="columns"
          :rows="GET_LIST_APPEAL"
          style-class="slots_text_align vgt-table bordered"
          :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
          :select-options="{
        enabled: false,
        selectOnCheckboxOnly: false,
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true,
        selectAllByGroup: true,
      }"
          :pagination-options="{
        enabled: false,
      }"
          :sort-options="{
        enabled: true,
      }"
          @on-row-click="dataRow"
      >
        <div slot="emptystate" class="text-center">{{ $t('empty_text') }}</div>

        <template slot="table-column" slot-scope="props" class="align-middle">
        <span>
          {{ $t(props.column.i18n) || props.column.label }}
        </span>
        </template>

        <template slot="table-row" slot-scope="props" class="align-middle">
        <span
            v-if="props.column.field === 'priority'"
            class="text-nowrap d-flex justify-content-center"
        >
          <b-badge :variant="props.row.priority.color">
            {{ props.row.priority.title }}
          </b-badge>
        </span>

          <span
              v-else-if="props.column.field === 'status'"
              class="text-nowrap d-flex justify-content-center"
          >
          <b-badge :variant="props.row.status.color">
            {{ props.row.status.title }}
          </b-badge>
        </span>
        </template>
      </vue-good-table>
    </b-card>

    <b-card>
      <template>
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0">
            <span class="text-nowrap">{{ $t('pagination.show_from') }}</span>
            <b-form-select
                v-model="params.page_size"
                :options="['1','2', '3']"
                class="mx-1"
                @change="changePerPage"
            />
            <span class="text-nowrap">{{ $t('pagination.lines') }}</span>
          </div>

          <b-pagination
              v-model="params.page"
              @change="changePage"
              :total-rows="GET_LIST_APPEAL_COUNT"
              :per-page="params.page_size"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18"/>
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18"/>
            </template>
          </b-pagination>
        </div>
      </template>
    </b-card>

    <Sidebar :sidebar="sidebar" @hideSidebar="sidebar = false"/>
  </div>
</template>

<script>
import {
  BBadge,
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BPagination,
  BRow,
  VBToggle,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { VueGoodTable } from 'vue-good-table'
import Sidebar from './components/Sidebar.vue'
import chat from '@/views/modules/ListAppeal/components/chat'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Index',
  components: {
    VueGoodTable,
    BFormInput,
    BFormSelect,
    BPagination,
    BButton,
    BRow,
    BCol,
    vSelect,
    flatPickr,
    BFormGroup,
    BCard,
    BBadge,
    Sidebar,
    chat,
  },
  data() {
    return {
      searchTerm: '',
      sidebar: false,
      filter: {
        problem_type: null,
        priority: null,
        unique_name: null,
        start_time: null,
        end_time: null,
      },
      columns: [
        {
          label: '№',
          field: 'id',
          type: 'number',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'sla.problem_type',
          i18n: 'sla.problem_type',
          field: 'problem_type',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'contact.comment',
          i18n: 'sla.comment',
          field: 'comment',
          sortable: false,
          thClass: 'comment',
          tdClass: 'text-center',
        },
        {
          label: 'task_manager.priority',
          i18n: 'task_manager.priority',
          field: 'priority',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'status',
          i18n: 'status',
          field: 'status',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'sla.date_sync',
          i18n: 'sla.date_sync',
          field: 'synchronized_time',
          sortable: false,
          thClass: 'synchronized_time',
          tdClass: 'text-center',
        },
      ],
      params: {
        page_size: 3,
        page: 1,
        ordering: null,
        search: null,
      },
    }
  },
  mounted() {
    this.FETCH_LIST_APPEAL(this.filter)
    this.FETCH_LIST_APPEAL_PROBLEM_TYPE()
    this.FETCH_LIST_APPEAL_PRIORITY_FILTER()
    this.FETCH_LIST_APPEAL_STATUS_FILTER()
  },
  methods: {
    ...mapActions('listAppeal', [
      'FETCH_LIST_APPEAL',
      'FETCH_LIST_APPEAL_SIDEBAR',
      'FETCH_LIST_APPEAL_PROBLEM_TYPE',
      'FETCH_LIST_APPEAL_PRIORITY_FILTER',
      'FETCH_LIST_APPEAL_STATUS_FILTER',
    ]),

    filterProblem() {
      this.FETCH_LIST_APPEAL(this.filter)
    },
    filterPriority() {
      this.FETCH_LIST_APPEAL(this.filter)
    },
    filterStatus() {
      this.FETCH_LIST_APPEAL(this.filter)
    },
    dataRow(data) {
      this.sidebar = data.row.id
      this.FETCH_LIST_APPEAL_SIDEBAR(this.sidebar)
    },
    changePage(value) {
      this.params.page = value
      this.FETCH_LIST_APPEAL(this.params)
    },
    changePerPage(page_size) {
      this.params.page_size = page_size
      this.params.page = 1
      this.FETCH_LIST_APPEAL(this.params)
    },
    resetInputFields() {
      this.filter.problem_type = null
      this.filter.priority = null
      this.filter.status = null
      this.filter.start_time = null
      this.filter.end_time = null
    },
  },
  computed: {
    ...mapGetters('listAppeal', [
      'GET_LIST_APPEAL',
      'GET_LIST_APPEAL_COUNT',
      'GET_LIST_APPEAL_PROBLEM_TYPE',
      'GET_LIST_APPEAL_PRIORITY_FILTER',
      'GET_LIST_APPEAL_STATUS_FILTER',
    ]),
  },
  watch: {
    'filter.start_time': {
      handler() {
        this.FETCH_LIST_APPEAL(this.filter)
      },
    },
    'filter.end_time': {
      handler() {
        this.FETCH_LIST_APPEAL(this.filter)
      },
    },
  },
  directives: {
    'b-toggle': VBToggle,
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.comment {
  padding: 15px 70px !important;
  text-align: center;
}

.synchronized_time {
  padding: 15px 0 !important;
  text-align: center!important;
}
</style>
